function pemToArrayBuffer(pem) {
  const b64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/g, '')
    .replace(/-----END PUBLIC KEY-----/g, '')
    .replace(/\s+/g, '')
  const bin = atob(b64)
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return bytes.buffer
}

function bytesToB64(bytes) {
  let bin = ''
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i])
  return btoa(bin)
}

export async function fetchTransportPublicKey(api) {
  const res = await api.get('/crypto/transport-public-key')
  return res.data?.public_key_pem
}

export async function encryptSecureProfile(publicKeyPem, profileObj) {
  if (!publicKeyPem) throw new Error('missing public key')

  const enc = new TextEncoder()
  const plaintext = enc.encode(JSON.stringify(profileObj))

  // AES-256-GCM 随机 key + iv
  const aesKeyRaw = crypto.getRandomValues(new Uint8Array(32))
  const iv = crypto.getRandomValues(new Uint8Array(12))

  const aesKey = await crypto.subtle.importKey('raw', aesKeyRaw, { name: 'AES-GCM' }, false, ['encrypt'])
  const ctBuf = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, aesKey, plaintext)

  // RSA-OAEP(SHA-256) 加密 AES key
  const spki = pemToArrayBuffer(publicKeyPem)
  const rsaKey = await crypto.subtle.importKey(
    'spki',
    spki,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  )
  const ekBuf = await crypto.subtle.encrypt({ name: 'RSA-OAEP' }, rsaKey, aesKeyRaw)

  return {
    v: 1,
    alg: 'RSA-OAEP-256+AES-256-GCM',
    ek: bytesToB64(new Uint8Array(ekBuf)),
    iv: bytesToB64(iv),
    ct: bytesToB64(new Uint8Array(ctBuf))
  }
}

export async function encryptSecureObject(publicKeyPem, obj) {
  if (!publicKeyPem) throw new Error('missing public key')
  const enc = new TextEncoder()
  const plaintext = enc.encode(JSON.stringify(obj || {}))
  const aesKeyRaw = crypto.getRandomValues(new Uint8Array(32))
  const iv = crypto.getRandomValues(new Uint8Array(12))
  const aesKey = await crypto.subtle.importKey('raw', aesKeyRaw, { name: 'AES-GCM' }, false, ['encrypt'])
  const ctBuf = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, aesKey, plaintext)
  const spki = pemToArrayBuffer(publicKeyPem)
  const rsaKey = await crypto.subtle.importKey(
    'spki',
    spki,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  )
  const ekBuf = await crypto.subtle.encrypt({ name: 'RSA-OAEP' }, rsaKey, aesKeyRaw)
  return {
    v: 1,
    alg: 'RSA-OAEP-256+AES-256-GCM',
    ek: bytesToB64(new Uint8Array(ekBuf)),
    iv: bytesToB64(iv),
    ct: bytesToB64(new Uint8Array(ctBuf))
  }
}

